import { createFileRoute } from "@tanstack/react-router";
import { BlackfeoCatalogoPage } from "@/components/blackfeo/BlackfeoCatalogoPage";

const URL = "https://fisioemortopedia.com.br/blackfeo-entregas";
const T = "BLACKFEO · Seu material está no e-mail | FEO";
const D = "Seu material gratuito já está no seu e-mail. Aproveite a BLACKFEO: todos os produtos da FEO com até 80% de desconto.";

export const Route = createFileRoute("/blackfeo-entregas")({
  validateSearch: (s: Record<string, unknown>): { preview?: boolean } =>
    s.preview === "1" || s.preview === 1 || s.preview === true ? { preview: true } : {},
  head: () => ({
    meta: [
      { title: T },
      { name: "description", content: D },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: T },
      { property: "og:description", content: D },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: T },
      { name: "twitter:description", content: D },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <BlackfeoCatalogoPage entregas preview={Route.useSearch().preview === true} />,
});
